/**
 * Promise version of `setTimeout`
 */
export function delay(milliseconds: number) {
  return new Promise<void>((resolve) =>
    setTimeout(() => resolve(), milliseconds)
  );
}
